import React, {Component} from "react";
import PropTypes from "prop-types";
import Form from 'react-bootstrap/Form';
import ConnectsTo from "../ConnectsTo";
import {Button, ButtonGroup, DropdownButton, InputGroup} from "react-bootstrap";
import {FaRegTrashAlt} from "react-icons/fa";
import Dropdown from "react-bootstrap/Dropdown";

class Oscillator extends Component {
  static propTypes = {
    config: PropTypes.object,
    connectables: PropTypes.array,
    deleteTool: PropTypes.func,
    setToolConfig: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {};

    this.deleteSetting = this.deleteSetting.bind(this);
    this.setDuration = this.setDuration.bind(this);
    this.setFrequency = this.setFrequency.bind(this);
    this.setSettingFrequency = this.setSettingFrequency.bind(this);
    this.setTime = this.setTime.bind(this);
    this.setToolId = this.setToolId.bind(this);
    this.setWaveType = this.setWaveType.bind(this);
  }

  deleteSetting = (index) => {
    this.props.config.settings.splice(index, 1);
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setDuration = (event) => {
    this.props.config.duration = parseFloat(event.target.value);
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setFrequency = (event) => {
    this.props.config.frequency = parseFloat(event.target.value);
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setSettingFrequency = (settingName, frequency) => {
    this.props.config.settings = this.props.config.settings.map(setting => {
      if(setting.name === settingName){
        setting.frequency = parseInt(frequency,10);
      }
      return setting;
    });
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setTime = (settingName, time) => {
    this.props.config.settings = this.props.config.settings.map(setting => {
      if(setting.name === settingName){
        setting.time = parseFloat(time);
      }
      return setting;
    });
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setToolId = (event) => {
    const newToolId = event.target.value;
    let config = Object.assign({}, this.props.config);
    config.id = newToolId;
    this.props.setToolConfig(this.props.config.id, config);
  }

  setWaveType = (event) => {
    this.props.config.waveType = event.target.value;
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  render() {
    return (
        <div className={"oscillator toolChainTool"}>
          <h3>Oscillator</h3>
          <Button variant={"danger"} onClick={() => {this.props.deleteTool(this.props.config.id)}}><FaRegTrashAlt /></Button>
          <DropdownButton as={ButtonGroup} title="+Setting" id="bg-nested-dropdown">
            <Dropdown.Item eventKey="cancelScheduledValues" onClick={this.addSetting}>cancelScheduledValues</Dropdown.Item>
            <Dropdown.Item onClick={this.addSetting}>cancelAndHoldAtTime</Dropdown.Item>
            <Dropdown.Item eventKey="exponentialRampToValueAtTime">exponentialRampToValueAtTime</Dropdown.Item>
            <Dropdown.Item eventKey="linRampToValueAtTime">linRampToValueAtTime</Dropdown.Item>
            <Dropdown.Item eventKey="setTargetAtTime">setTargetAtTime</Dropdown.Item>
            <Dropdown.Item eventKey="setValueAtTime">setValueAtTime</Dropdown.Item>
            <Dropdown.Item eventKey="setValueCurveAtTime">setValueCurveAtTime</Dropdown.Item>
          </DropdownButton>
          <InputGroup>
            <InputGroup.Text>id</InputGroup.Text>
            <Form.Control type="text" value={this.props.config.id}
                          onChange={this.setToolId}/>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Frequency</InputGroup.Text>
            <Form.Control type={"number"} min={10} max={30000} step={100}
                          value={this.props.config.frequency}
                          onChange={this.setFrequency}/>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Duration</InputGroup.Text>
            <Form.Control type={"number"} min={0.1} max={5} step={0.1}
                value={this.props.config.duration}
                onChange={this.setDuration}/>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Wave Type</InputGroup.Text>
            <Form.Select value={this.props.config.waveType}
                         onChange={this.setWaveType}>
              <option>sine</option>
              <option>square</option>
              <option>sawtooth</option>
              <option>triangle</option>
            </Form.Select>
          </InputGroup>
          <div className={"toolSettings"}>
            {this.props.config.settings && this.props.config.settings.map((setting, index) => (
                <div className={"toolSetting"} key={index}>
                  <Form.Group>
                    <InputGroup>
                      <Form.Select defaultValue={setting.name} onChange={()=>{console.log("test")}}>
                        <option value={"cancelScheduledValues"}>cancelScheduledValues</option>
                        <option value={"cancelAndHoldAtTime"}>cancelAndHoldAtTime</option>
                        <option value={"exponentialRampToValueAtTime"}>expRampToValueAtTime</option>
                        <option value={"linRampToValueAtTime"}>linRampToValueAtTime</option>
                        <option value={"setTargetAtTime"}>setTargetAtTime</option>
                        <option value={"setValueAtTime"}>setValueAtTime</option>
                        <option value={"setValueCurveAtTime"}>setValueCurveAtTime</option>
                      </Form.Select>
                      <Button variant={"secondary"} onClick={()=>{this.deleteSetting(index)}}>x</Button>
                    </InputGroup>
                    <Form.Range min={1} max={20000} step={100}
                                value={setting.frequency}
                                onChange={(event) => this.setSettingFrequency(setting.name, event.target.value)}/>
                    <Form.Range min={.001} max={5} step={.1}
                                value={setting.time}
                                onChange={(event) => this.setTime(setting.name, event.target.value)}/>
                  </Form.Group>
                </div>
            ))}
          </div>
          <ConnectsTo
              connectables={this.props.connectables}
              config={this.props.config}
              setToolConfig={this.props.setToolConfig}/>
        </div>
    );
  }
}

export default Oscillator;